import { useEffect, useState } from "react";
import {
  useGetCustomerOrderAreaChart,
  useGetCustomerOrderCountChart,
  useGetCustomerOrderRegisterCountChart,
} from "../../../Production/OrderArchive/Hook";
import dayjs from "dayjs";
import moment from "moment-jalaali";

const useChartCustomerLogic = () => {
  const orderType = [
    {
      count: "",
      color: "#3592FB",
      title: "سفارشات",
      key: "total_1_1",
    },
    {
      count: "",
      color: "rgba(154, 64, 224, 1)",
      title: "خرابی",
      key: "total_1_2",
    },
    {
      count: "",
      color: "rgba(76, 175, 80, 1)",
      title: "تجدید ساخت",
      key: "total_1_3",
    },
    {
      count: "",
      color: "rgba(255, 152, 0, 1)",
      title: "اصلاحیه",
      key: "total_1_4",
    },
  ];

  //register
  const { data: registerData, mutate: registerMutate } =
    useGetCustomerOrderRegisterCountChart();
  //count
  const { data: chartCustomer, mutate } = useGetCustomerOrderCountChart();

  //area chart fetch data
  const { mutate: areaMutate, data } = useGetCustomerOrderAreaChart();

  //data stat for display in chart
  const [countState, setCountState] = useState([]);

  // tab filter
  const [activeFilterType, setActiveFilterType] = useState(1);
  const [dateForSubmit, setDateForSubmit] = useState({
    year: 0,
    month: 0,
    day: 0,
  });
  const [datePicker, setDatePicker] = useState(dayjs());

  const changeActiveFilterType = (type) => {
    setActiveFilterType(type);
  };

  //*total count state
  useEffect(() => {
    if (activeFilterType === 1) {
      setCountState(chartCustomer?.data?.data?.items);
    }
    if (activeFilterType === 2) {
      setCountState(data?.data?.data?.items2);
    }
    if (activeFilterType === 3) {
      setCountState(registerData?.data?.data?.items);
    }
    if (activeFilterType === 4) {
      setCountState(registerData?.data?.data?.items);
    }
  }, [chartCustomer, data, registerData]);

  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [receivedFileTypeId, setReceivedFileTypeId] = useState(null);
  const handleChange = (event) => {
    setReceivedFileTypeId(event.target.checked);
  };

  /* ------------------------------- DatePicker ------------------------------- */
  const formatDatePicker = (chartFilter) => {
    if (chartFilter.name === "all") {
      return moment(datePicker).locale("en").format("jYYYY");
    }
    if (chartFilter.name === "year") {
      return moment(datePicker).locale("en").format("jYYYY");
    } else if (chartFilter.name === "mondth") {
      return moment(datePicker).locale("en").format("jYYYY/jMM");
    } else if (chartFilter.name === "day") {
      return moment(datePicker).locale("en").format("jYYYY/jMM/jDD");
    }
  };

  const dateSubmit = (splitDate, chartFilter) => {
    if (chartFilter.name === "all") {
      setDateForSubmit({
        year: 0,
        month: 0,
        day: 0,
      });
    } else if (chartFilter.name === "year") {
      setDateForSubmit({
        year: splitDate[0],
        month: 0,
        day: 0,
      });
    } else if (chartFilter.name === "mondth") {
      setDateForSubmit({
        year: splitDate[0],
        month: splitDate[1],
        day: 0,
      });
    } else if (chartFilter.name === "day") {
      setDateForSubmit({
        year: splitDate[0],
        month: splitDate[1],
        day: splitDate[2],
      });
    }
  };
  useEffect(() => {
    const dateSelect = formatDatePicker(chartFilter);
    const splitDate = dateSelect.split("/");
    dateSubmit(splitDate, chartFilter);
  }, [datePicker, chartFilter]);

  /* ------------------------------- re-Render ------------------------------ */
  useEffect(() => {
    if (activeFilterType === 1)
      mutate({
        chartReportTiming: chartFilter.enum,
        receivedFileTypeId: receivedFileTypeId,
        ...dateForSubmit,
      });
    if (activeFilterType === 2)
      areaMutate({
        chartReportTiming: chartFilter.enum,
        receivedFileTypeId: receivedFileTypeId,
        ...dateForSubmit,
      });
    if (activeFilterType === 3)
      registerMutate({
        chartReportTiming: chartFilter.enum,
        receivedFileTypeId: receivedFileTypeId,
        ...dateForSubmit,
      });
    if (activeFilterType === 4)
      registerMutate({
        chartReportTiming: chartFilter.enum,
        receivedFileTypeId: receivedFileTypeId,
        ...dateForSubmit,
      });
  }, [activeFilterType, receivedFileTypeId, dateForSubmit]);

  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
          ? { name: "mondth", enum: 1 }
          : type === "year"
            ? { name: "year", enum: 2 }
            : { name: "all", enum: 3 },
    );
  };
  return {
    data: {
      orderType,
      countState,
      activeFilterType,
      chartFilter,
      setReceivedFileTypeId,
      receivedFileTypeId,
      datePicker,
    },
    action: {
      changeActiveFilterType,
      tabHandler,
      handleChange,
      setDatePicker,
    },
  };
};
export default useChartCustomerLogic;
